var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { mapCreateQuestionToApiRequest } from './mapper';
// Get all questions for a question set with options
export function getQuestionSetQuestions(questionSetId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(`/api/internal/component_question_sets/${questionSetId}/questions`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching question set questions:', error);
            return {
                error: {
                    message: 'Failed to fetch questions for question set'
                }
            };
        }
    });
}
// Create a new question and add it to a question set
export function createQuestionForSet(questionSetId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = mapCreateQuestionToApiRequest(data);
            const response = yield api.post(`/api/internal/component_question_sets/${questionSetId}/questions`, requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error creating question for question set:', error);
            return {
                error: {
                    message: 'Failed to create question for question set'
                }
            };
        }
    });
}
// Remove a question from a question set
export function removeQuestionFromSet(questionSetId, questionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.delete(`/api/internal/component_question_sets/${questionSetId}/questions/${questionId}`);
            return {};
        }
        catch (error) {
            console.error('Error removing question from question set:', error);
            return {
                error: {
                    message: 'Failed to remove question from question set'
                }
            };
        }
    });
}
// Export default object with all functions
export default {
    getQuestionSetQuestions,
    createQuestionForSet,
    removeQuestionFromSet
};
